<template>
  <BaseLayout>
    <div>
      <div v-if="showChrome" class="header-bar">
        <MainMenu />
      </div>

      <div :class="showChrome ? 'mt-15' : ''">
        <router-view />
      </div>
    </div>
  </BaseLayout>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import BaseLayout from "../BaseLayout.vue";
import MainMenu from "./MainMenu.vue";

const route = useRoute();
// Login y las páginas de pago son pantalla completa: sin la barra superior del sitio.
const showChrome = computed(
  () => !["login", "pay", "pay-result", "my-plan"].includes(String(route.name))
);
</script>
